import type { Cart, InvoiceFormFields } from '@/modules/cart/domain/Cart';
import type { CartRepository } from '@/modules/cart/domain/CartRepository';

const saveBillingAddress = async (
  repository: CartRepository,
  addressPayload: InvoiceFormFields
): Promise<Cart> => {
  return repository.saveBillingAddress(addressPayload).then((cart) => {
    if (!cart) {
      throw new Error('No se pudo guardar el usuario');
    }
    return cart;
  });
};

export default saveBillingAddress;
